module.exports = __webpack_public_path__ + "img/DP014C_001.a9504102.png";